export default __webpack_public_path__ + "static/wave_solutions-580a8a53f15f750513c216e5ff2d17c6.png";